import { forwardRef, useEffect, type ReactNode } from 'react';

interface BlockedAppContentProps {
  shouldBlockInteraction: boolean;
  children: ReactNode;
}

export const BlockedAppContent = forwardRef<HTMLDivElement, BlockedAppContentProps>(
  function BlockedAppContent({ shouldBlockInteraction, children }, ref) {
    useEffect(() => {
      const element = ref && 'current' in ref ? ref.current : null;
      if (!element) return;

      if (shouldBlockInteraction) {
        element.setAttribute('inert', '');
        element.setAttribute('aria-hidden', 'true');
      } else {
        element.removeAttribute('inert');
        element.removeAttribute('aria-hidden');
      }
    }, [ref, shouldBlockInteraction]);

    return <div ref={ref}>{children}</div>;
  }
);
